export default __webpack_public_path__ + "static/media/ico-preparing.6a3f2bef.svg";